import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import LoadingBlock from './shared/LoadingBlock'
import ScheduleSummary from './ScheduleSummary'
import { useLiveAnchorLocks } from '../hooks/useLiveAnchorLocks'
import { useLiveEndRuleByArm } from '../hooks/useLiveEndRuleByArm'
import { useScheduleActions } from '../hooks/useScheduleActions'

const AnchorSection = lazy(() => import('./AnchorSection'))
const AvailabilitySection = lazy(() => import('./AvailabilitySection'))
const RepeatSection = lazy(() => import('./RepeatSection'))
const AudienceSection = lazy(() => import('./AudienceSection'))
const ParticipantPermissionsSection = lazy(() => import('./ParticipantPermissionsSection'))

const ScheduleEditor = ({
  schedule,
  scheduleIndex,
  entityOptions,
  study,
  disabled,
  showParticipantSession,
  instrumentName,
}) => {
  useLiveAnchorLocks(schedule, entityOptions)
  useLiveEndRuleByArm(schedule, entityOptions)
  const { schedules } = useScheduleActions()
  return (
    <div className='se-schedule-editor'>
      <Suspense fallback={<LoadingBlock label='Loading anchors…' />}>
        <AnchorSection
          schedule={schedule}
          scheduleIndex={scheduleIndex}
          entityOptions={entityOptions}
          disabled={disabled}
        />
      </Suspense>
      <Suspense fallback={<LoadingBlock label='Loading availability…' />}>
        <AvailabilitySection
          schedule={schedule}
          scheduleIndex={scheduleIndex}
          entityOptions={entityOptions}
          disabled={disabled}
        />
      </Suspense>
      <Suspense fallback={<LoadingBlock label='Loading repeat…' />}>
        <RepeatSection
          schedule={schedule}
          scheduleIndex={scheduleIndex}
          study={study}
          entityOptions={entityOptions}
          disabled={disabled}
        />
      </Suspense>
      <Suspense fallback={<LoadingBlock label='Loading audience…' />}>
        <AudienceSection
          schedule={schedule}
          scheduleIndex={scheduleIndex}
          entityOptions={entityOptions}
          disabled={disabled}
          showEproLabel={showParticipantSession}
        />
      </Suspense>
      {showParticipantSession ? (
        <Suspense fallback={<LoadingBlock label='Loading permissions…' />}>
          <ParticipantPermissionsSection schedule={schedule} disabled={disabled} />
        </Suspense>
      ) : null}
      <ScheduleSummary
        schedule={schedule}
        scheduleIndex={scheduleIndex}
        entityOptions={entityOptions}
        instrumentName={instrumentName}
        scheduleCount={schedules.length}
      />
    </div>
  )
}

ScheduleEditor.propTypes = {
  schedule: PropTypes.object,
  scheduleIndex: PropTypes.number,
  entityOptions: PropTypes.object,
  study: PropTypes.object,
  disabled: PropTypes.bool,
  showParticipantSession: PropTypes.bool,
  instrumentName: PropTypes.string,
}

export default ScheduleEditor
